module.exports = "/wwwroot/img/accordion_block.png?ver=7dc16323";